import { render } from "./FlipCardGame.vue?vue&type=template&id=508149d6&scoped=true"
import script from "./FlipCardGame.vue?vue&type=script&lang=js"
export * from "./FlipCardGame.vue?vue&type=script&lang=js"

import "./FlipCardGame.vue?vue&type=style&index=0&id=508149d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508149d6"]])

export default __exports__